import axiosInstance from "../../interceptor/intercetptor-inctence"



export const getSuppliersAPI = (data) => {
	return axiosInstance.post(`pharma/get-suppliers`, data)
}

export const createSupplierAPI = (data) => {
	return axiosInstance.post(`pharma/add-supplier`, data)
}

export const viewSupplierAPI = (data) => {
	return axiosInstance.post(`pharma/view-supplier-details`, data)
}

export const updateSupplierAPI = (data) => {
	return axiosInstance.patch(`pharma/update-supplier`, data)
}

export const deleteSupplierAPI = (data) => {
	return axiosInstance.post(`pharma/soft-delete-supplier`, data)
}

export const suppliersMasterAPI = (data) => {
	return axiosInstance.post(`pharma/get-master-suppliers`, data);
}

export const getStateMaster = (data) => {
	return axiosInstance.post(`pharma/masterStates`, data);
}

export const getDistrictMaster = (data) => {
	return axiosInstance.post(`pharma/masterDistrict`, data);
}

export const getCityMaster = (data) => {
	return axiosInstance.post(`pharma/masterCity`, data);
}

export const getPinCodeMaster = (data) => {
	return axiosInstance.post(`pharma/masterByPincode`, data);
}